module.exports = __webpack_public_path__ + "static/img/25墨创.0a16505.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/25墨创.jpg
// module id = b3eV
// module chunks = 1